import React from 'react';

const ProjectCard = ({ id, name, zip_code, gross_area, work_type, main_building_use, project_template_name, project_template_description, is_template, selectProject = null, removeProject = null, editProject = null, subscription = null, editable = true }) => {

    const handleSelectProject = () => {
        selectProject();
    }

    const handleRemoveProject = (e) => {
        e.stopPropagation();
        removeProject();
    }
    const handleEditProject = (e) => {
        e.stopPropagation();
        editProject();
    }

    return (
        <div className="card mb-3 tour-search" style={{ maxWidth: '100%', cursor: 'pointer' }}>
            <div className="card-body p-0" style={{ borderRadius: '3px', }} onClick={() => { editable && handleSelectProject() }}>
                <div className='d-flex flex-row justify-content-between' style={{ backgroundColor: '#e7e7e7', padding: '5px 15px' }}>
                    <h5 className="card-title m-0" style={{ fontSize: '16px', fontWeight: '600', fontFamily: 'Gotham, sans-serif', color: '#626262', textTransform: 'capitalize' }}>{!is_template ? name?.toLowerCase() : project_template_name?.toLowerCase()}</h5>
                    <div>
                        {(subscription?.plan !== 'no-plan' && editable) &&
                            <>
                                <i className="bi bi-pencil-square px-2" onClick={handleEditProject}></i>
                                <i className="bi bi-trash3-fill" onClick={handleRemoveProject}></i>
                            </>
                        }
                    </div>
                </div>
                <div className="card-text" style={{ padding: '5px 15px' }}>
                    {!is_template ? (
                        <>
                            <div className='d-flex flex-row justify-content-between px-2'><span style={{ fontSize: '16px', fontWeight: '500', marginTop: '2px', textAlign:'left', width:'50%' }}>Zipcode</span> <span style={{width:'50%', textAlign:'right'}}>{zip_code}</span> <br /></div>
                            <div className='d-flex flex-row justify-content-between px-2'><span style={{ fontSize: '16px', fontWeight: '500', marginTop: '2px', textAlign:'left', width:'50%' }}>Gross Area</span> <span style={{width:'50%', textAlign:'right'}}>{gross_area}</span><br /></div>
                        </>
                    ) : (
                        <>
                        <div className='d-flex flex-row justify-content-start px-2'><span style={{ fontSize: '16px', fontWeight: '500', marginTop: '2px' }}></span> <p>{project_template_description}</p> <br /></div>
                        </>
                    )
                    }
                    <div className='d-flex flex-row justify-content-between px-2'><span style={{ fontSize: '16px', fontWeight: '500', marginTop: '2px', textAlign:'left', width:'50%' }}>Work Type</span> <span style={{width:'50%', textAlign:'right'}}>{work_type} </span><br /></div>
                    <div className='d-flex flex-row justify-content-between px-2'><span style={{ fontSize: '16px', fontWeight: '500', marginTop: '2px', textAlign:'left', width:'50%' }}>Main Building Use</span> <span style={{width:'50%', textAlign:'right'}}>{main_building_use}</span></div>
                </div>
            </div>
        </div>
    );
};

export default ProjectCard;
